export const createObjectSdrn = (
  providerId: string,
  entity: string,
  id?: string,
): string => `sdrn:${providerId}:${entity.toLowerCase()}:${id ?? 'unknown'}`;
